import React from 'react';
import PropTypes from 'prop-types';
// import Cleave from 'cleave.js/react';
// import 'cleave.js/dist/addons/cleave-phone.i18n';
import PhoneNumber from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import './FormComponents.scss';

// const USPhoneRegex = /(?:^|\D)\(([2-9])(?:\d(?!\1)\d|(?!\1)\d\d)\)\s*[2-9]\d{2}-\d{4}/;

export default class PhoneInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: (this.props.phonePrefix + this.props.value.replace(this.props.phonePrefix, '')) || '',
      phoneCleave: null,
    };

    this.onPhoneInit = this.onPhoneInit.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value !== this.props.value) {
      const phoneValue = this.props.phonePrefix + nextProps.value.replace(this.props.phonePrefix, '');
      this.onPhoneChange(phoneValue);
    }
  }

  onPhoneInit(cleave) {
    this.setState({
      phoneCleave: cleave,
    }, () => {
      this.state.phoneCleave.setRawValue(this.state.value);
    });
  }

  onPhoneChange(rawValue) {
    this.setState({
      value: rawValue,
    }, () => {
      this.props.onChange({
        target: {
          type: 'tel',
          name: this.props.name,
          value: `+${rawValue.replace(/[^0-9]+/g, '')}`,
        },
      });
    });
  }


  render() {
     const { className } = this.props;
    const { value } = this.state;
    return (
      <div className="phone-input__input">
        {/* <span className="phone-input__prefix">{phonePrefix}</span> */}
        {/* <Cleave
          placeholder={placeholder}
          options={{ phone: true }}
          onChange={this.onPhoneChange}
          onBlur={this.props.onBlur}
          className={className}
          onInit={this.onPhoneInit}
        /> */}
        <PhoneNumber
          defaultCountry={'us'}
          // onlyCountries={['us']}
          inputClass={className}
          value={value}
          onChange={(val) => { return this.onPhoneChange(val); }}
        />
      </div>
    );
  }
}

PhoneInput.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  phonePrefix: '+1',
  placeholder: 'Enter phone number',
  name: 'phone',
  value: '',
  className: '',
};

PhoneInput.propTypes = {
  onChange: PropTypes.func,
  // onBlur: PropTypes.func,
  phonePrefix: PropTypes.string,
  // placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  //className: PropTypes.string,
};
